
<template>
  <div>
    <b-card class="d-none d-md-block mb-2 no-body">
      <div class="row">
        <div class="col-6">
          <table>
            <tr>
              <td>
                <strong>Löneperiod:</strong>&nbsp;
              </td>
              <td>{{salarySpecification.salaryPeriodStartDate | moment("YYYY-MM-DD")}} - {{salarySpecification.salaryPeriodEndDate | moment("YYYY-MM-DD")}}</td>
            </tr>
            <tr>
              <td>
                <b>Avvikelser t.o.m:</b>&nbsp;
              </td>
              <td>{{salarySpecification.abberationToDate | moment("YYYY-MM-DD")}}</td>
            </tr>
            <tr>
              <td>
                <b>Bankkontonummer:</b>&nbsp;
              </td>
              <td>{{salarySpecification.user.bankAccountNumber}}</td>
            </tr>
          </table>
        </div>
        <div class="col-6">
          <table class="float-right">
            <tr>
              <td>{{salarySpecification.user.name}}</td>
            </tr>
            <tr>
              <td>{{salarySpecification.user.address}}</td>
            </tr>
            <tr>
              <td>{{salarySpecification.user.postalcode}} {{salarySpecification.user.city}}</td>
            </tr>
          </table>
        </div>
      </div>
    </b-card>

    <b-card class="d-block d-md-none mb-2 no-body">
        <table>
          <tr>
            <td>
              <strong>Löneperiod:</strong>&nbsp;
            </td>
            <td>{{salarySpecification.salaryPeriodStartDate | moment("YYYY-MM-DD")}} - {{salarySpecification.salaryPeriodEndDate | moment("YYYY-MM-DD")}}</td>
          </tr>
          <tr>
            <td>
              <b>Avvikelser t.o.m:</b>&nbsp;
            </td>
            <td>{{salarySpecification.abberationToDate | moment("YYYY-MM-DD")}}</td>
          </tr>
          <tr>
            <td>
              <b>Bankkontonummer:</b>&nbsp;
            </td>
            <td>{{salarySpecification.user.bankAccountNumber}}</td>
          </tr>
        </table>
    </b-card>

    <b-card class="d-block d-md-none mb-2 no-body">
      <table>
        <tr>
          <td>{{salarySpecification.user.name}}</td>
        </tr>
        <tr>
          <td>{{salarySpecification.user.address}}</td>
        </tr>
        <tr>
          <td>{{salarySpecification.user.postalcode}} {{salarySpecification.user.city}}</td>
        </tr>
      </table>
    </b-card>
  </div>
</template>

<script>
export default {
      props: ["salarySpecification"],
};
</script>

<style>
</style>
